import { PlpFacetedSearchSubPage, PlpSubpage } from "./use-plp-subpage";

export const plpSubpageTags = {
  root: "root" as const,
  facetedSearch: "faceted-search" as const,
  category: "category" as const,
  subfamily: "subfamily" as const,
  product: "product" as const,
  productSpareParts: "product-spare-parts" as const,
};

export const plpSubpage = {
  root: (data: { openedFilterTabByFilterKey: string | undefined }): PlpSubpage => ({
    tag: plpSubpageTags.root,
    openedFilterTabByFilterKey: data.openedFilterTabByFilterKey,
  }),
  facetedSearch: (data: {
    activatedFacets: PlpFacetedSearchSubPage["activatedFacets"];
    openedFilterTabByFilterKey: string | undefined;
  }): PlpSubpage => ({
    tag: plpSubpageTags.facetedSearch,
    activatedFacets: data.activatedFacets,
    openedFilterTabByFilterKey: data.openedFilterTabByFilterKey,
  }),
  category: (data: { categoryKey: string }): PlpSubpage => {
    return {
      tag: plpSubpageTags.category,
      ...data,
    };
  },
  subfamily: (data: { categoryKey: string; subfamilyKey: string }): PlpSubpage => {
    return {
      tag: plpSubpageTags.subfamily,
      ...data,
    };
  },
  product: (data: { categoryKey: string; subfamilyKey: string; productKey: string }): PlpSubpage => {
    return {
      tag: plpSubpageTags.product,
      ...data,
    };
  },
  productSpareParts: (data: { categoryKey: string; subfamilyKey: string; productKey: string }): PlpSubpage => {
    return {
      tag: plpSubpageTags.productSpareParts,
      ...data,
    };
  },
};
